import { render, staticRenderFns } from "./aPage.vue?vue&type=template&id=3b2bd140"
import script from "./aPage.vue?vue&type=script&lang=js"
export * from "./aPage.vue?vue&type=script&lang=js"
import style0 from "./aPage.vue?vue&type=style&index=0&id=3b2bd140&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VImg,VMain})
